import { useSelector } from 'react-redux';
import { can as canBase, canAny as canAnyBase, canAll as canAllBase } from '../utils/roleUtils';
import { useCallback } from 'react';

export const usePermissions = () => {
  const currentRole = useSelector(state => state.auth.user?.currentRole);
  const shop = useSelector(state => state.auth.shop);

  //   const can = (roleName) => canBase(currentRole, roleName);
  const can = useCallback((...requiredPermission) => canBase(currentRole, shop, ...requiredPermission), [
    currentRole,
    shop
  ]);
  const canAny = useCallback((...requiredPermissions) => canAnyBase(currentRole, shop, ...requiredPermissions), [
    currentRole,
    shop
  ]);
  const canAll = useCallback((...requiredPermissions) => canAllBase(currentRole, shop, ...requiredPermissions), [
    currentRole,
    shop
  ]);

  return {
    can,
    canAny,
    canAll
  };
};
